'use strict'

const JobOfferSelect = {
    init: function() {
        this.constructor();
        this.handleChange();
    },
    constructor() {
        this.selectLocation = document.querySelector('.job-list-filter-location');
        this.selectDepartment = document.querySelector('.job-list-filter-department');
    },
    handleChange() {
        if(!this.selectLocation) return;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const location = urlParams.get('location')
        const department = urlParams.get('department')

        this.selectLocation.value = location;
        this.selectDepartment.value = department;

        if (!location) this.selectLocation.selectedIndex = 0;
        if (!department) this.selectDepartment.selectedIndex = 0;

        this.selectLocation.onchange = () => {
            const url = new URL(window.location.href);
            
            url.searchParams.delete("location");
            url.searchParams.delete("department");

            if (this.selectLocation.value) url.searchParams.append("location", this.selectLocation.value)
            if (department) url.searchParams.append("department", department)

            window.location.href = url.href;
        }

        this.selectDepartment.onchange = () => {
            const url = new URL(window.location.href);

            url.searchParams.delete("location");
            url.searchParams.delete("department");
            
            if (location) url.searchParams.append("location", location)
            if (this.selectDepartment.value) url.searchParams.append("department", this.selectDepartment.value)

            window.location.href = url.href;
        }
    }
}


export default JobOfferSelect;